import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class LoadMoreGrants {

    constructor() {
        this.settings = {
            $grantsList: $(".js-grants-list")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$grantsList != null) {

            let grantsList = this.settings.$grantsList; // The container element that holds the list of grants grants
            let loadNr = $('#js-nr-grants-default').val(); // The number of grants to load
            let loadMoreBtn = $(".js-load-more-grants"); // The button that triggers the loading of more grants

            function grantsTypeList() {
                // Remove hidden class from all the grants
                $('.js-grants-single').removeClass('hidden');

                grantsList.find('.js-grants-single').each(function (index) {

                    // Hide grants that have a higher index than the number of grants to load
                    if (index >= loadNr) {
                        $(this).addClass('hidden');
                    }
                });
            }

            grantsTypeList();

            // Hide the load more button if there are no more reports to load initially
            if (grantsList.find('.hidden').length === 0) {
                loadMoreBtn.removeClass('btn');
                loadMoreBtn.addClass('hidden');
            }

            // Load more grants when the button is clicked
            loadMoreBtn.on('click',  (e) => {

                const $this = e.currentTarget;

                let moregrants =  grantsList.find('.hidden'); // The grants that are currently hidden
                let counter = 0; // Counter to keep track of the number of grants that have been shown
                moregrants.each(function () {

                    // Stop the loop when the number of grants that have been shown is equal to the number of grants to load
                    if (counter >= loadNr) {
                        return false;
                    }

                    // Increment the counter
                    counter++;

                    // Show the grants
                    $(this).removeClass('hidden');
                });

                // Hide the load more button if there are no more grants to load
                if (grantsList.find('.hidden').length === 0) {
                    $this.classList.remove('btn');
                    $this.classList.add('hidden');
                }

                ScrollTrigger.refresh();
            });

        }

    }
};

new LoadMoreGrants();